import React, { useState } from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  TextField, Button, Stack 
} from '@mui/material';

const AddVariationPopup = ({ onClose, onAdd, editingVariation, product_id }) => {
  console.log("Editing Variation: ", editingVariation);
  const [variation, setVariation] = useState(
    editingVariation || {
      attribute: '',
      name: '',
      sku: '',
      price: '',
      stock: '',
      product_id
    }
  );

  const [attributeError, setAttributeError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVariation({ ...variation, [name]: value });

    // Clear error when user types something valid
    if (name === 'attribute' && value.trim() !== '') {
      setAttributeError(false);
    }
  };

  const handleSubmit = () => {
    // Safe validation check using fallback to empty string
    if ((variation.attribute || '').trim() === '') {
      setAttributeError(true);
      return;
    }

    onAdd(variation);
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{editingVariation ? 'Edit Variation' : 'Add Variation'}</DialogTitle>
      
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Attribute"
            name="attribute"
            value={variation.attribute}
            onChange={handleChange}
            fullWidth
            required
            error={attributeError}
            helperText={attributeError ? "Attribute is required" : ""}
          />
          <TextField
            label="Name"
            name="name"
            value={variation.name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="SKU"
            name="sku"
            value={variation.sku}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Price"
            name="price"
            type="number"
            value={variation.price}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Stock"
            name="stock"
            type="number"
            value={variation.stock}
            onChange={handleChange}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {editingVariation ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddVariationPopup;
